import { render, staticRenderFns } from "./SettsTerms.vue?vue&type=template&id=f89144d8&scoped=true"
import script from "./SettsTerms.vue?vue&type=script&lang=js"
export * from "./SettsTerms.vue?vue&type=script&lang=js"
import style0 from "./SettsTerms.vue?vue&type=style&index=0&id=f89144d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89144d8",
  null
  
)

export default component.exports